import {Layout} from 'antd';
import AccessDeniedAlert from '../alert/AccessDeniedAlert';
import Spinner from '../spinners/Spinner';
import {useModulePolicy} from '../../../hooks/useModulePolicy';
import {useScopes} from '../../../hooks/useScopes';
import {useStore} from '../../../hooks/useStore';

export const Content = (props) => {
  const scopes = useScopes();
  const store = useStore();
  const policy = useModulePolicy(store, scopes);

  const {
    background = '#fff',
    padding = 24,
    loading = false,
    style = {},
    children,
  } = props;
  let content = <AccessDeniedAlert/>;

  if (policy.canView()) {
    if (loading) {
      content = <Spinner fullWidth/>;
    } else {
      content = children;
    }
  }

  return (
    <Layout.Content style={{margin: '12px 12px 0 12px', ...style}}>
      <div style={{padding, background, minHeight: 360}}>
        {content}
      </div>
    </Layout.Content>
  );
};
